import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PasswordSettings from './PasswordSettings';
import UserSettings from './UserSettings';
import { PageHeading, Skeleton } from 'src/common';
import { faUserNinja } from '@fortawesome/pro-light-svg-icons';
import { useSsoConfig } from 'src/models/company/Security/hooks';
import { isFreeUser, useApp } from 'src/models/auth';

export const AccountSettings: FC = () => {
  const { t } = useTranslation();
  const { user } = useApp();
  const isFree = useMemo(() => isFreeUser(user), [user]);
  const { enforceSSO: isEnforceSso, loading: ssoLoading } = useSsoConfig();

  return (
    <>
      <PageHeading
        title={t('Navigation.Settings.myProfile')}
        desc={t('Account.accountSettingsDesc')}
        icon={faUserNinja}
      />
      <UserSettings />
      {ssoLoading ? <Skeleton loading active /> : <>{(!isEnforceSso || isFree) && <PasswordSettings />}</>}
    </>
  );
};
